import * as React from "react";

const PowerIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#7C3AED"
            d="m18.55 26.2 5.175-6.2h-4l.725-5.675L15.825 21H19.3zM16 30l1-7h-5l9-13h2l-1 8h6L18 30z"
        ></path>
    </svg>
);

export default PowerIconSVG;
